import { faEnvelope, faSignIn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, LoadingOverlay, Paper, Stack, Text, TextInput, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useMediaQuery } from '@mantine/hooks';
import { useEffect } from 'react';
import { UseMutationResult } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import Alert from '../../../component/common/alert';
import { NAV } from '../../../config/navigation';
import { IErrorObject } from '../../../services/types';
import { formPaperHeadingStyle, formPaperStyle, formPaperStyleLarge } from '../../login/styles';
import { IResetPasswordFormProps } from '../types';
interface ResetPasswordFormProps {
  hookForm: UseFormReturnType<IResetPasswordFormProps>;
  onResetPassword: UseMutationResult<void, IErrorObject, IResetPasswordFormProps, void>;
}

export default function ResetPasswordForm({ hookForm, onResetPassword }: ResetPasswordFormProps) {
  const form = hookForm;
  const { mutate, isError, error, isLoading, isSuccess } = onResetPassword;
  const largeScreen = useMediaQuery('(min-width: 800px)');
  const navigate = useNavigate();

  const handleSubmit = ({ email }: IResetPasswordFormProps) => {
    mutate({ email: email.toLowerCase() });
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(`/reset-password/sent`);
    }
  }, [isSuccess, navigate]);

  return (
    <Paper withBorder shadow={'md'} sx={largeScreen ? formPaperStyleLarge : formPaperStyle}>
      <Title align="center" order={2} styles={formPaperHeadingStyle}>
        Create Password
      </Title>

      {isError && <Alert mt="1rem" message={error?.error?.message} />}

      <form onSubmit={form.onSubmit(values => handleSubmit(values))}>
        <Stack spacing={10} mt="3rem">
          <LoadingOverlay visible={isLoading} />

          <TextInput
            type="email"
            {...form.getInputProps('email')}
            label="Email"
            placeholder="email address"
            icon={<FontAwesomeIcon icon={faEnvelope} />}
          />

          <Button type="submit" px={50} mt="lg">
            Create Password
          </Button>
        </Stack>
        <Text size="sm" mt={'lg'}>
          <FontAwesomeIcon icon={faSignIn} style={{ paddingRight: '0.5rem' }} />
          Already signed up?
          <div>
            <Text<typeof Link> component={Link} to={NAV.LOGIN} underline size="sm" color="#228be6" pl={'3px'}>
              Click here to log in
            </Text>
          </div>
        </Text>
      </form>
    </Paper>
  );
}
